import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'

export interface GA4ClickEventProps extends GA4GeneralProps {
  selectedOption?: string | null
}

export class GA4ClickEvent extends GA4Event {
  ga4_selected_option: string | null

  constructor({ selectedOption = null, ...generalProps }: GA4ClickEventProps) {
    super({ event: EVENT.CLICK, ...generalProps })

    this.ga4_selected_option = selectedOption
  }
}
